import React, { useState } from "react";
import api from "@/lib/api";
import { Section } from "@/components/app/Primitives";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

/**
 * FMCG Customer status-update request. Since Unilever (and other FMCG) users
 * are now READ-ONLY in the AdFluence-first flow, this page is their only
 * channel to nudge ProPay Procurement Desk for a status update.
 */
export default function CustomerStatusRequest() {
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!msg.trim()) return toast.error("Please enter your request");
    setBusy(true);
    try {
      await api.post("/customer/status-update-request", { message: msg.trim() });
      toast.success("Request sent to ProPay Procurement Desk — you'll receive a reply in your inbox.");
      setMsg("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed to send");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-6" data-testid="customer-status-request">
      <Section
        title="Request status update"
        subtitle="Unilever operations are handled end-to-end by ProPay Procurement Desk (AdFluence-sourced campaigns). Use this form to request a status update, escalation, or clarification — a Procurement Buyer will respond."
      />

      <div className="rounded-xl border bg-white p-6 space-y-4 max-w-2xl">
        <div>
          <label className="text-xs uppercase tracking-widest font-bold text-slate-500">Your message to ProPay Procurement</label>
          <Textarea
            rows={6}
            value={msg}
            onChange={(e) => setMsg(e.target.value)}
            placeholder="e.g. Please share the current status of the Diwali 2026 Bru Coffee campaign — specifically, has Priya Sharma's KYS been completed?"
            data-testid="status-request-textarea"
          />
        </div>
        <div className="text-[11px] text-slate-500 italic">
          Your request is logged in the ProPay audit trail. EY audit team (on behalf of Unilever) will also see this record for compliance purposes.
        </div>
        <Button
          onClick={submit}
          disabled={busy || !msg.trim()}
          className="bg-[#0052FF] hover:bg-[#0043D9] h-11 px-8"
          data-testid="submit-status-request-btn"
        >
          {busy ? "Sending…" : "Send request to Procurement Desk"}
        </Button>
      </div>
    </div>
  );
}
